import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-regular-svg-icons';
import { faCircle as faCircleSolid, faCircleX } from '@fortawesome/pro-solid-svg-icons';
import moment from 'moment';
import OrderStatusDisplayType from '../../OrderStatusDisplayType';

function OrderStatusDisplayFactory({ orderStatusType, shipDate }) {
  switch (orderStatusType) {
    case OrderStatusDisplayType.PARTIAL:
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} className="text-success" />
          {' '}
          Partial
        </div>
      );
    case OrderStatusDisplayType.SHIPPED:
      return (
        <div>
          <FontAwesomeIcon icon={faCircleSolid} className="text-success" />
          {' '}
          Shipped
          {' '}
          <span className="font-italic">
            {moment.unix(shipDate).format('MMM DD, YYYY')}
          </span>
        </div>
      );
    case OrderStatusDisplayType.DELIVERED:
      return (
        <div>
          <FontAwesomeIcon icon={faCircleSolid} className="text-success" />
          {' '}
          Delivered
        </div>
      );
    case OrderStatusDisplayType.RECEIVED:
    case OrderStatusDisplayType.HOLD:
      return (
        <div>
          <FontAwesomeIcon icon={faCircle} className="text-success" />
          {' '}
          Received
        </div>
      );
    case OrderStatusDisplayType.CANCELLED:
      return (
        <div>
          <FontAwesomeIcon icon={faCircleX} className="text-muted" />
          {' '}
          Cancelled
        </div>
      );

    default:
      return (<div> - </div>);
  }
}

OrderStatusDisplayFactory.propTypes = {
  orderStatusType: PropTypes.number.isRequired,
  shipDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.any,
  ]),
};

OrderStatusDisplayFactory.defaultProps = {
  shipDate: null,
};

export default OrderStatusDisplayFactory;
